<template>
  <div class="full-width">
    <v-expansion-panels flat class="outlined-panel">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between">
            <span class="panel-title font-weight-bold primary--text"
              >Penanda Anatomi Tubuh</span
            >
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <anatomy-marker-content
            ref="anatomyContent"
            :marksProp="data || []"
            :gender="gender"
            :is-doctor="isDoctor"
            :tooltip-mode="'none'"
            :injury-types="injuryTypes"
            @toggle-show-all="toggleShowAll"
            @save="saveInput"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- The v-tooltip for showing all marks still needs access to the refs -->
    <!-- It remains here because it's tied to the parent's coordinate system -->
    <!-- <div v-if="tooltipMode === 'all'" ref="multipleTooltip">
      <v-tooltip
        v-for="mark in marks"
        :key="`all-${mark.idx}`"
        v-model="showAllTooltips"
        content-class="custom-tooltip"
        top
      >
        <template v-slot:activator="{ on }">
          <div v-on="on" :style="getFixedPositionStyle(mark)"></div>
        </template>
        <div>
          <ul style="margin: 0; padding-left: 1.2em;">
            <li v-if="mark.description">{{ mark.description }}</li>
            <li v-if="mark.woundType">{{ mark.woundType }}</li>
            <li>
              P: {{ mark.dimensions?.length?.value || '-' }}
              {{ mark.dimensions?.length?.unit || '' }}, L:
              {{ mark.dimensions?.width?.value || '-' }}
              {{ mark.dimensions?.width?.unit || '' }}
              <span v-if="mark.dimensions?.depth?.value">
                , D: {{ mark.dimensions?.depth?.value }}
                {{ mark.dimensions?.depth?.unit }}
              </span>
            </li>
          </ul>
        </div>
      </v-tooltip>
    </div> -->
  </div>
</template>

<script>
import Constant from '@/const';
const axios = require('axios');
import AnatomyMarkerContent from './AnatomicalMark/AnatomyMarkerContent.vue';

export default {
  name: 'AnatomyMarker',
  components: {
    AnatomyMarkerContent,
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    gender: {
      type: Boolean,
      default: false,
    },
    isDoctor: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // tooltipMode: 'none',
      showAllTooltips: false,
      showSingleTooltip: false,
      currentSingleIndex: -1,
      injuryTypes: [],
      sizeUnits: ['mm', 'cm'],
    };
  },

  mounted() {
    this.getInjuryType();
  },

  methods: {
    async getInjuryType() {
      const response = await axios.get(
        Constant.apiUrl.concat('/master/injury-type'),
      );
      if (response) {
        this.injuryTypes = response.data.data;
      }
    },
    toggleShowAll() {
      if (this.marks.length === 0) return;
      this.tooltipMode = 'all';
      this.showAllTooltips = this.tooltipMode === 'all';
      this.showSingleTooltip = false;
      this.currentSingleIndex = -1;
    },
    saveInput(marks) {
      this.$emit('save', marks);
    },
    // getFixedPositionStyle(mark) {
    //   const stageRef = this.$refs.anatomyContent.$refs[mark.bodyPart];
    //   if (!stageRef) return { display: 'none' };
    //   const stage = stageRef.getStage();
    //   const rect = stage.container().getBoundingClientRect();
    //   const offsetX = 20;
    //   const offsetY = 20;
    //   return {
    //     position: 'fixed',
    //     left: `${rect.left + mark.position.x + offsetX}px`,
    //     top: `${rect.top + mark.position.y + offsetY}px`,
    //     width: '0px',
    //     height: '0px',
    //     pointerEvents: 'none',
    //   };
    // },
  },
};
</script>

<style lang="scss" scoped>
/* Styles remain unchanged */
.full-width {
  width: 100%;
}
.panel-title {
  font-size: 1.4rem;
}
.outlined-panel {
  margin: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  width: 100%;
  :deep(.v-expansion-panel-header) {
    border-bottom: none !important;
  }
  :deep(.v-expansion-panel--active) {
    border-radius: 8px;
  }
}
</style>
